import { useEffect } from "react";
import { useAuth } from "@xinosolutions/xs-auth-react";

/**
 * ThemeProvider mounts before auth hydrates. Re-fetch color scheme once the
 * session is ready so saved associate branding is applied after refresh.
 */
export default function ThemeColorAuthSync() {
  const { isAuthenticated, loading, sessionEpoch } = useAuth();

  useEffect(() => {
    if (loading || !isAuthenticated) return;
    window.dispatchEvent(new Event("user-login"));
  }, [loading, isAuthenticated, sessionEpoch]);

  return null;
}
